export const blockClass =
  'bg-[#EAEAEA] rounded-[20px] lg:p-4 p-2 flex lg:flex-row flex-col-reverse lg:gap-8 gap-2';

export const blockLeftStyle = '';
export const blockRightStyle = 'flex flex-auto';
